import React from 'react';
import './SearchBar.css';

export const SearchBar = ({
  value,
  onChange,
  onClear,
  placeholder = "Search cards...",
  isActive
}) => {
  return (
    <div className={`search-bar ${isActive ? 'active' : ''}`}>
      <span className="search-icon">🔍</span>
      <input
        type="text"
        className="search-input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoFocus={isActive}
      />
      {value && (
        <button
          className="search-clear"
          onClick={onClear}
          aria-label="Clear search"
        >
          ✕
        </button>
      )}
    </div>
  );
};
